var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInventoryLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 53,
    viewBox: "0 0 59 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0262 20.9258H3.76317C3.44863 20.9258 3.19727 21.1771 3.19727 21.5549L5.71263 51.4275C5.77537 52.308 6.53034 52.9998 7.41077 52.9998H22.4414C23.3219 52.9998 24.0765 52.308 24.1396 51.4275L26.655 21.5549C26.5918 21.2403 26.3404 20.9258 26.0259 20.9258H26.0262Z",
    fill: "#FF5910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2481 36.8993H57.6052C58.1083 36.8993 58.4856 36.3962 58.4229 35.893C57.857 32.6857 55.027 30.1699 51.6308 30.1699H36.2228C32.8269 30.1699 29.9966 32.6226 29.4307 35.893C29.3679 36.3962 29.7452 36.8993 30.2484 36.8993H30.2481Z",
    fill: "#FF5910"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6054 46.334H30.2484C29.7452 46.334 29.3679 46.8372 29.4307 47.3403C29.9966 50.5476 32.8265 53.0002 36.2228 53.0002H51.6308C55.0266 53.0002 57.857 50.5475 58.4229 47.3403C58.5488 46.774 58.1715 46.334 57.6056 46.334H57.6054Z",
    fill: "#FF5910"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7306 39.2891H30.1849C29.7444 39.2891 29.3672 39.6663 29.3672 40.1068V43.1254C29.3672 43.5658 29.7445 43.9431 30.1849 43.9431H57.7306C58.1711 43.9431 58.5483 43.5658 58.5483 43.1254V40.1068C58.5483 39.6668 58.1711 39.2891 57.7306 39.2891Z",
    fill: "#FF5910"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.531 14.8256H15.7706V5.58083L21.1791 2.05911C21.4305 1.87047 21.4936 1.55593 21.305 1.30456L20.6132 0.235493C20.4245 -0.0158753 20.11 -0.0790461 19.8586 0.10959L13.8842 4.00865C13.5697 4.26002 13.3183 4.63772 13.3183 5.01499V14.9516H2.12392C1.18075 14.9516 0.425781 15.7061 0.425781 16.6497V17.027C0.425781 17.9702 1.18032 18.7251 2.12392 18.7251H27.4685C28.4117 18.7251 29.1667 17.9706 29.1667 17.027V16.6497C29.229 15.5806 28.474 14.8257 27.5309 14.8257L27.531 14.8256Z",
    fill: "#FF5910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryLevel);
export default __webpack_public_path__ + "static/media/InventoryLevel.5251cb40081fd78d4a564b0cf2f5991b.svg";
export { ForwardRef as ReactComponent };